import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FeedbackContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { disciplineClient } from '../client/disciplineClient';


export const useDisciplineCrud = () => {
  const { genericErrorFeedback } = React.useContext(FeedbackContext);

  const queryClient = useQueryClient();


  const likeDiscipline = useMutation({
    mutationKey: [cacheKeys.likeDiscipline],
    mutationFn: (id: number) => disciplineClient.likeDiscipline({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getDisciplines],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getDiscipline, id],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const unlikeDiscipline = useMutation({
    mutationKey: [cacheKeys.unlikeDiscipline],
    mutationFn: (id: number) => disciplineClient.unlikeDiscipline({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getDisciplines],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getDiscipline, id],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const ignoreDiscipline = useMutation({
    mutationKey: [cacheKeys.ignoreDiscipline],
    mutationFn: (id: number) => disciplineClient.ignoreDiscipline({ id }),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getDisciplines],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getDiscipline, id],
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    likeDiscipline: likeDiscipline,
    unlikeDiscipline: unlikeDiscipline,
    ignoreDiscipline: ignoreDiscipline,
  };
};
